import { addDoc, serverTimestamp } from 'firebase/firestore'

import { setRefCollection } from '@/lib/firestore/refs/set-firestore-refs'
import { type Set } from '@/models/set/set.model'
import { handleError } from '@/error/handle-error'

export async function createSet({ data }: { data: Set }) {
  try {
    const docRef = await addDoc(setRefCollection, data)

    return docRef.id
  } catch (error) {
    handleError(error, 'Failed to create set')
  }
}

export const getDefaultSet = ({
  userId,
  language,
  nativeLanguage,
  displayName,
  additionalLanguages,
  defaultAssignmentRepeat,
  defaultRubricId,
  organizationId,
  subjects,
}: {
  userId?: string
  language?: string
  nativeLanguage?: string
  displayName?: string
  additionalLanguages?: string[]
  defaultAssignmentRepeat?: number
  defaultRubricId?: string
  organizationId?: string
  subjects?: string[]
}) => {
  const set = {
    name: '',
    description: '',
    image: {
      url: '',
      path: null,
    },
    content: [],
    owners: [userId],
    language: language ?? 'en',
    defaultLanguage: nativeLanguage ?? 'en',
    public: true,
    tags: [],
    ownerName: displayName ?? '',
    createdAt: serverTimestamp(),
    additionalLanguages: additionalLanguages ?? [],
    repeat: defaultAssignmentRepeat ?? 1,
    defaultRubricId: defaultRubricId ?? null,
    mcAllowRetries: true,
    status: 'draft',
    subjects: subjects ?? [],
  } as Partial<Set>

  if (organizationId) {
    set.organizations = [organizationId]
  }

  return set
}
